import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
    useEffect(() => {
        const kill = () => {
            const el = document.getElementById("emergent-badge");
            if (el && el.parentNode) el.parentNode.removeChild(el);
        };
        kill();
        const observer = new MutationObserver(kill);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#0E2138",
                        color: "#F8F7F4",
                        border: "1px solid rgba(248,247,244,0.14)",
                        borderRadius: "2px",
                        fontFamily: "Inter Tight, sans-serif",
                        fontSize: "13px",
                        letterSpacing: "-0.005em",
                    },
                }}
            />
        </div>
    );
}

export default App;
